<template>
  <div>
    <button class="btn btn-info mb-2" @click.prevent="openItemModal">
      <i class="fas fa-plus"></i> Thêm
    </button>
    <b-table bordered head-variant="dark" hover responsive :fields="fields" :items="items" table-variant="light">
      <template
        v-slot:cell(thoigian)="data"
      >{{data.item.tungay | moment('DD/MM/YYYY')}} - {{data.item.toingay | moment('DD/MM/YYYY')}}</template>
      <template v-slot:cell(sotiennhanviendong)="data">{{formatPrice(data.item.sotiennhanviendong)}}</template>
      <template v-slot:cell(sotiencongtyhotro)="data">{{formatPrice(data.item.sotiencongtyhotro)}}</template>
      <template v-slot:cell(action)="data">
        <button class="btn btn-info mr-2" @click="openUpdateItemModal(data)">
          <i class="fas fa-eye"></i>
        </button>
        <button class="btn btn-danger" @click="deleteItem(data)">
          <i class="fas fa-trash-alt"></i>
        </button>
      </template>
    </b-table>
    <b-modal
      v-model="modalShow"
      header-bg-variant="info"
      header-text-variant="light"
      size="xl"
      @ok="storeItem"
    >
      <template v-slot:modal-title>
        <div v-if="item_selected.id <= 0">Thêm thông tin phúc lợi</div>
        <div v-else>Cập nhật thông tin phúc lợi</div>
      </template>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button v-if="item_selected.id <= 0" variant="success" @click="ok()">Thêm</b-button>
        <b-button v-else variant="success" @click="ok()">Cập nhật</b-button>
        <b-button variant="danger" @click="cancel()">Đóng</b-button>
      </template>
      <b-form class="mr-4" autocomplete="off" @submit="ok()">
        <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">Tên chương trình</label>
            <code>*</code>
          </b-col>
          <b-col cols="9">
            <b-form-input v-model="item_selected.tenchuongtrinh" required></b-form-input>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">Địa điểm</label>
          </b-col>
          <b-col cols="9">
            <b-form-input v-model="item_selected.diadiem" required></b-form-input>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">Từ ngày</label>
          </b-col>
          <b-col cols="3">
            <vue-datepicker-local
              v-model="item_selected.tungay"
              :local="local"
              clearable
              format="DD/MM/YYYY"
            />
          </b-col>
          <b-col cols="1"></b-col>
          <b-col cols="2">
            <label class="mr-2">Tới ngày</label>
          </b-col>
          <b-col cols="3">
            <vue-datepicker-local
              v-model="item_selected.toingay"
              :local="local"
              clearable
              format="DD/MM/YYYY"
            />
          </b-col>
        </b-form-row>
        <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">Số tiền nhân viên đóng</label>
          </b-col>
          <b-col cols="3">
            <my-currency-input v-model="item_selected.sotiennhanviendong" />
          </b-col>
          <b-col cols="1"></b-col>
          <b-col cols="2">
            <label class="mr-2">Số tiền công ty hỗ trợ</label>
          </b-col>
          <b-col cols="3">
            <my-currency-input v-model="item_selected.sotiencongtyhotro" />
          </b-col>
        </b-form-row>
        <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">Ghi chú</label>
          </b-col>
          <b-col cols="9">
            <b-form-textarea v-model="item_selected.ghichu" rows="2"></b-form-textarea>
          </b-col>
        </b-form-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import VueDatepickerLocal from "vue-datepicker-local";
import "vue-datepicker-local/dist/vue-datepicker-local.css";
import MyCurrencyInput from "../App/MyCurrencyInput";
export default {
  name: "PhucLoi",
  props: ["item"],
  components: {
    VueDatepickerLocal,
    MyCurrencyInput,
  },
  data() {
    return {
      modalShow: false,
      items: [],
      itemIdex: null,
      fields: [
        {
          key: "tenchuongtrinh",
          label: "Tên chương trình",
        },
        {
          key: "diadiem",
          label: "Địa điểm",
        },
        {
          key: "thoigian",
          label: "Thời gian",
        },
        {
          key: "sotiennhanviendong",
          label: "Số tiền nhân viên đóng",
        },
        {
          key: "sotiencongtyhotro",
          label: "Số tiền công ty hỗ trợ",
        },
        {
          key: "action",
          label: "",
          thStyle: { width: "150px !important" },
        },
      ],
      local: {
        monthsHead: "Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12".split(
          "_"
        ), // months of head
        months: "Th 1_Th 2_Th 3_Th 4_Th 5_Th 6_Th 7_Th 8_Th 9_Th 10_Th 11_Th 12".split(
          "_"
        ), // months of panel
        weeks: "CN_T2_T3_T4_T5_T6_T7".split("_"), // weeks,
      },
      item_null: {
        id: 0,
        employeeid: 0,
        tenchuongtrinh: null,
        diadiem: null,
        tungay: null,
        toingay: null,
        sotiennhanviendong: 0,
        sotiencongtyhotro: 0,
        ghichu: null,
      },
      item_selected: {
        id: 0,
        employeeid: 0,
        tenchuongtrinh: null,
        diadiem: null,
        tungay: null,
        toingay: null,
        sotiennhanviendong: 0,
        sotiencongtyhotro: 0,
        ghichu: null,
      },
    };
  },
  created() {
    if (this.item != null) this.initData();
  },
  methods: {
    formatPrice(value) {
      let val = value / 1;
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    initData() {
      axios
        .get(`/api/employeewelfare/${this.item.id}`)
        .then((response) => {
          this.items = response.data;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },
    openItemModal() {
      this.item_selected = JSON.parse(JSON.stringify(this.item_null));
      this.item_selected.employeeid = this.item.id;
      this.modalShow = true;
    },
    openUpdateItemModal(data) {
      this.item_selected = JSON.parse(JSON.stringify(data.item));
      this.itemIdex = data.index;
      this.modalShow = true;
    },
    storeItem(bvModalEvt) {
      if (
        !(
          this.item_selected.tenchuongtrinh &&
          this.item_selected.tenchuongtrinh.length
        )
      ) {
        this.$toast.error("Vui lòng nhập đầy đủ thông tin", "Lỗi", {
          timeout: 2000,
        });
        bvModalEvt.preventDefault();
      } else {
        if (this.item_selected.id <= 0) {
          axios
            .post("/api/employeewelfare", this.item_selected)
            .then((res) => {
              this.modalShow = false;
              this.items.push(res.data);
            })
            .catch((err) => {
              this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
            });
        } else {
          axios
            .put("/api/employeewelfare", this.item_selected)
            .then((res) => {
              this.modalShow = false;
              this.items[this.itemIdex] = JSON.parse(
                JSON.stringify(this.item_selected)
              );
              const temp = JSON.parse(JSON.stringify(this.items));
              this.items = JSON.parse(JSON.stringify(temp));
              this.itemIdex = null;
            })
            .catch((err) => {
              this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
            });
        }
      }
    },
    deleteItem(data) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              axios
                .delete(`/api/employeewelfare/${data.item.id}`)
                .then((res) => {
                  this.items.splice(data.index, 1);
                  this.$toast.success("Xóa thành công !", "Thành công", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Lỗi", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function (instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
